import { render, staticRenderFns } from "./AxTags.vue?vue&type=template&id=53839ffc&"
import script from "./AxTags.vue?vue&type=script&lang=js&"
export * from "./AxTags.vue?vue&type=script&lang=js&"
import style0 from "./AxTags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports